// extracted by mini-css-extract-plugin
export default {"leftSectionMobile":"LeftSectionMobile_leftSectionMobile__dQyo-"};